import { SxProps, Theme, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioColors } from "../../configuration/themeSettings";

export const useStylesCss = () => {
  const theme = useTheme();

  const classes = {
    general: {
      fontSize: 14,
      minWidth: 160,
    },
    circle: {
      backgroundColor: theme.palette.common.white,
      borderRadius: 100,
      justifyContent: 'center',

      "svg":{
        margin: '0 !important',
      },
      



      "&:hover": {
        backgroundColor: theme.palette.common.white,
        color: MiscSavio.hoverColor,
        borderColor: MiscSavio.hoverColor,
      },


      "&.negative":{
        backgroundColor: theme.palette.primary.main,
        color: StyleguideSavioColors.white,
        "svg":{
          color: StyleguideSavioColors.white,
        },

        "&:hover":{
          backgroundColor: StyleguideSavioColors.blue,
        }
      }
    },
    circleBig: {
      backgroundColor: theme.palette.common.white,
      borderRadius: 100,
      width: 74,
      height: "74px !important",
      transitionProperty: "transform",
      transitionDuration: "0.4s",
      transformOrigin: "center",
      justifyContent: 'center',
      svg: { fontSize: "1.5em" },
      
      "&:hover": {
        backgroundColor: theme.palette.common.white,
        transform: "scale(1.2) !important",
        color: MiscSavio.hoverColor,
        borderColor: MiscSavio.hoverColor,
      },
    },
    modalHeader: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      borderRadius: 100,
      width: 40,
      height: 40,
      //transitionProperty: "transform",
      //transitionDuration: "0.4s",
      //transformOrigin: "center",
      svg: { fontSize: 22 },
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        //transform: "scale(1.2) !important",
      },
    },

    circleWithoutAnimation: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 100,
      width: 40,
      height: 40,
      transitionProperty: "backgroundColor",
      transitionDuration: "0.4s",
      justifyContent: 'center',
      svg: { fontSize: 22 },
      color: theme.palette.common.white,
      
      "&:hover": {
        backgroundColor:  MiscSavio.hoverColor,
      },
    },

    circleWithoutAnimationSecondary: {
      backgroundColor: StyleguideSavioColors.lighterGrey,
     
    
      color: theme.palette.primary.main,
      
      "&:hover": {
        backgroundColor: StyleguideSavioColors.lighterGrey,
        color:  MiscSavio.hoverColor,
      },
    },

    int:{
      width: 33,
      height:33,
      borderRadius:0,
      border: '1px solid '+ StyleguideSavioColors.lightGrey,
      background: 'linear-gradient(184deg, rgba(255,255,255,1) 0%, rgba(242,246,249,1) 100%)',
      "svg":{
        fontSize: 12,
      },
      "*":{
        borderRadius: "0 !important",
      },
    },
    
    width: {
      minWidth: 160,
    } as SxProps<Theme>,
  };
  return classes;
};

